import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row } from 'react-flexbox-grid';
import cn from 'classnames';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import Details from '../event_components/details';
import AttendButton from '../event_components/attend_button';
import styles from './tile.scss';
import PaddedComponent from './top_padder';
import GoogleLocation from '../event_components/google_location';
import ConferenceData from '../event_components/conference_data';
import EventStatus from '../event_components/event_status';

PaddedComponent.propTypes = {
  children: PropTypes.node,
};

function Tile({ event, settings, noTitle = false, className = '' }) {
  const hasLogo = settings.get('showEventLogo');
  return (
    <Row className={cn('event', styles.tile, styles.event, className)}>
      {hasLogo && (
        <div className={styles.header}>
          <Logo event={event} className={styles.photo} settings={settings} />
          {!noTitle && <Title event={event} className={styles.title} />}
        </div>
      )}
      <div className={styles.container}>
        <PaddedComponent>
          <Time
            withIcon
            event={event}
            settings={settings}
            className={styles.time}
            // format="ddd D MMM YYYY HH:mm"
          />
        </PaddedComponent>
        <PaddedComponent>
          {settings.get('calendarType') === 'google' ? (
            <GoogleLocation event={event} />
          ) : (
            <Location event={event} withIcon />
          )}
        </PaddedComponent>
        {event.has('conferenceData') && (
          <PaddedComponent>
            <ConferenceData event={event} />{' '}
          </PaddedComponent>
        )}
        {settings.get('showEventStatus') && (
          <PaddedComponent>
            <EventStatus event={event} settings={settings} />
          </PaddedComponent>
        )}
        <PaddedComponent>
          <Details event={event} settings={settings} className={styles.details} withIcon />
        </PaddedComponent>

        <div style={{ flexGrow: 1 }} />
        {!settings.get('removeAttendButton') && (
          <AttendButton event={event} settings={settings} className={styles.buttonRow} />
        )}
      </div>
    </Row>
  );
}

Tile.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export default Tile;



// WEBPACK FOOTER //
// ./src/widget/event_layouts/tile.js